const genderOptions = [
    {gender_id: 1, gender_name: "Male"}, 
    {gender_id: 2, gender_name: "Female"}, 
    {gender_id: 3, gender_name: "Non-binary"}
];

export default genderOptions;